export const DRAWER_WIDTH = 270

export const PAGINATION_SELECT_OPTIONS = [10, 30, 60, 100]
